export default __webpack_public_path__ + "static/media/CNo.76-0.c136205d.jpg";